<template>
  <!-- _________________________ INITIATE PASSWORD _________________________ -->
  <div id="login-div">

    <div v-if="ui.showError">
      <h1 class=" page-title error-title mt-4">
        {{ $t('errorTitle') }}
      </h1>
      <h2 class="secondary-page-title mt-2">
        {{ $t('errorSubtitle') }}
      </h2>
      <div class="error-description mt-2">
        {{ $t('ERROR') }} : {{ ui.showErrorMessage }}
      </div>
    </div>

    <div v-if="ui.showExpiredError">
      <h1 class=" page-title expired-error-title mt-4">
        {{ $t('expiredErrorTitle') }}
      </h1>
      <h2 class="secondary-page-title mt-2">
        {{ $t('expiredErrorSubtitle') }}
      </h2>
      <div class="error-description mt-2">
        {{ $t('ERROR') }} : {{ ui.showErrorMessage }}
      </div>
      <h2 class="secondary-page-title mt-2">
        {{ $t('expiredErrorSecondSubtitle') }}
      </h2>

      <div class="mt-2">
        <form ref="expiredErrorForm" @submit.stop.prevent="handleResendEmail">
          <b-button type="submit" class="btn-block" variant="primary">{{ $t('expiredErrorBtn') }}</b-button>
        </form>
      </div>
    </div>

    <div v-if="ui.showSuccess">
      <h1 class=" page-title expired-error-title mt-4">
        {{ $t('Password.success.title') }}
      </h1>
      <h2 class="secondary-page-title mt-2" v-if="isMobile">
        {{ $t('Password.success.mobile') }}
      </h2>
      <h2 class="secondary-page-title mt-2" v-else>
        {{ $t('Password.success.web') }}
      </h2>
    </div>

    <div v-if="ui.showExpiredSuccess">
      <h1 class=" page-title expired-error-title mt-4">
        {{ $t('expiredErrorMailSent') }}
      </h1>
      <h2 class="secondary-page-title mt-2">
        {{ $t('expiredErrorMailSentSubtitle') }}
      </h2>
    </div>

    <div v-if="!ui.showError && !ui.showExpiredError && !ui.showSuccess && !ui.showExpiredSuccess">
      <h1 class="page-title login-title mt-4">
        {{ $t('loginTitle') }}
      </h1>
      <h2 class="secondary-page-title mt-2">
        {{ $t('Password.newPassword') }}
      </h2>

      <form ref="form" @submit.stop.prevent="handleSubmit" class="mt-4">

        <!-- Password -->
        <b-form-group
          :label="$t('Password')"
          label-for="password-input"
          :invalid-feedback="form.password.invalidFeedback"
          :state="form.password.state">
          <b-form-input
            id="password-input"
            v-model="form.password.value"
            :state="form.password.state"
            type="password"
            autocomplete="off"
            required>
          </b-form-input>
        </b-form-group>

        <!-- Password repeat -->
        <b-form-group
          :label="$t('Password.confirm')"
          label-for="passwordRepeat-input"
          :invalid-feedback="form.passwordRepeat.invalidFeedback"
          :state="form.passwordRepeat.state">
          <b-form-input
            id="passwordRepeat-input"
            v-model="form.passwordRepeat.value"
            :state="form.passwordRepeat.state"
            type="password"
            autocomplete="off"
            required>
          </b-form-input>
        </b-form-group>

        <div class="mt-4">
          <b-button type="submit" class="btn-block" variant="primary">{{ $t('Validate') }}</b-button>
        </div>

      </form>
    </div>

    <div class="mt-4 text-right" v-if="ui.showSuccess && !isMobile">
      <b-button v-on:click="backToLogin" class="btn-block" variant="primary">{{ $t('backToLoginText') }}</b-button>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ValidateAccountAndPasswordComponent',

  data() {
    return {
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      isMobile: true,
      form: {
        password: {
          value: null,
          state: null,
          invalidFeedback: null
        },
        passwordRepeat: {
          value: null,
          state: null,
          invalidFeedback: null
        }
      },
      ui: {
        showSuccess: false,
        showError: false,
        showExpiredError: false,
        showExpiredSuccess: false,
        showErrorMessage: ''
      }
    }
  },

  mounted() {
    this.checkToken()
  },

  methods: {

    checkToken() {
      let data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/authentication/checkActivationMailToken`,
        data: data
      })
        .then((response) => {
          this.isMobile = response.data.isMobile
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message).toUpperCase()
            this.ui.showError = true
          }
          if (error.response.status === 418) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message).toUpperCase()
            this.ui.showExpiredError = true
          }
        })
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('userId', this.userId)
      formData.append('password', this.form.password.value.trim())

      api({
        method: 'POST',
        url: `/authentication/initiatePasswordAndValidateAccount`,
        data: formData
      })
        .then(() => {
          this.ui.showExpiredSuccess = false
          this.ui.showSuccess = true
          this.ui.showExpiredError = false
          this.ui.showError = false
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.form.password.value == null || this.form.password.value.trim() === '') {
        this.form.password.state = false
        this.form.password.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.password.value.trim().length < 8) {
        this.form.password.state = false
        this.form.password.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      } else if (this.form.passwordRepeat.value == null || this.form.passwordRepeat.value.trim() === '') {
        this.form.passwordRepeat.state = false
        this.form.passwordRepeat.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.password.value !== this.form.passwordRepeat.value) {
        this.form.passwordRepeat.state = false
        this.form.passwordRepeat.invalidFeedback = this.$i18n.t('Password.not.corresponding')
        return false
      }
      return true
    },

    handleResendEmail() {

      let formData = new FormData()
      formData.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountAndPasswordMail`,
        data: formData
      })
        .then(() => {
          this.ui.showExpiredSuccess = true
          this.ui.showSuccess = false
          this.ui.showExpiredError = false
          this.ui.showError = false
        })
        .catch((error) => {
          this.$bvToast.toast(this.$i18n.t(error.response.data.message), {
            title: this.$i18n.t('Error.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          })
        })
    },

    backToLogin() {
      this.$emit('showLoginView')
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ValidateAccountAndPasswordComponent.vue